import { render, staticRenderFns } from "./api.vue?vue&type=template&id=ecb72176&scoped=true"
import script from "./api.vue?vue&type=script&lang=js"
export * from "./api.vue?vue&type=script&lang=js"
import style0 from "./api.vue?vue&type=style&index=0&id=ecb72176&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb72176",
  null
  
)

export default component.exports